import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-forest text-cream/70" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-2.5 h-2.5 rounded-full bg-clay" />
            <span className="font-serif text-2xl text-cream">Zenith</span>
          </div>
          <p className="text-sm leading-relaxed max-w-xs">
            Executive coaching & personal assistance for people who want clarity, focus, and time back.
          </p>
        </div>
        <div>
          <p className="overline text-clay mb-4">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/#services" className="hover:text-cream transition-colors">Services</Link></li>
            <li><Link to="/#approach" className="hover:text-cream transition-colors">Approach</Link></li>
            <li><Link to="/book" className="hover:text-cream transition-colors">Book a session</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-clay mb-4">Get in touch</p>
          <p className="text-sm">hello@zenithcoaching.com</p>
          <p className="text-sm mt-1">Mon–Sat · 9am–5pm</p>
        </div>
      </div>
      <div className="border-t border-cream/10 py-6 text-center text-xs text-cream/40">
        © {new Date().getFullYear()} Zenith Coaching. Crafted with intention.
      </div>
    </footer>
  );
}
